import { create } from 'zustand'

type CurrentCategory = {
  category: string
  setCategory: (category: string) => void
}

export const useCurrentCategory = create<CurrentCategory>((set) => ({
  category: '',
  setCategory: (category: string) => set({ category: category }),
}))
